import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { AmenityType, AvailableAmenity } from 'models/Amenity';
import { AvailableRule, RuleType } from 'models/Rule';
import { normalizeKey } from 'utils/localeUtils';
import { AmenityItemChildStyled } from './CategorizedAmenities.styles';
import AmenityEditIcon from './edit/AmenityEditIcon';
import { canEditAmenity } from './edit/AmenityEditModal.utils';

const AmenityItemChild = ({
  child,
  gridColumn,
  parentAmenityType,
}: {
  child: AvailableAmenity | AvailableRule;
  parentAmenityType: AmenityType | RuleType;
  gridColumn: number | null;
}) => {
  const value = 'amenityType' in child ? child.amenityType : child.rule;
  const name = `amenities.${value}.value`;
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();
  const amenityChildValue = watch(name);

  useEffect(() => {
    if (!amenityChildValue && child.supportsDescription) {
      setValue(`amenities.${value}.description`, null);
    }
  }, [amenityChildValue]);

  return (
    <AmenityItemChildStyled
      $gridColumn={gridColumn}
      key={value}
      data-testid={`amenity-type-${parentAmenityType}-child-${value}`}
    >
      <CheckboxField name={name}>
        {t(normalizeKey(`amenities.types.${value}`))}
      </CheckboxField>

      {canEditAmenity(child) && amenityChildValue && (
        <AmenityEditIcon amenity={child} />
      )}
    </AmenityItemChildStyled>
  );
};

export default AmenityItemChild;
